import React from 'react';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import AddDataPicker from 'subscriptions/AddDataPicker/quick';
import DataRemaining from 'subscriptions/DataRemaining/quick';
import * as routes from 'app/routes';
import styles from './AddData.module.css';
import add_data from 'common/img/add_data.svg';
import Back from 'common/Back';

export const AddDataScreen = ({ subId }) => {
  return (
    <div className={styles.AddData}>
      <SubscriptionSwitcher
        quickSubId={subId}
        quickRoute={routes.quickSubscription}
        bypassedRoute={routes.bypassedSubscription}
        sprintRoute={routes.sprintSubscription}
      />
      <div className={styles.Back}>
        <Back to={routes.quickSubscription(subId)} />
      </div>
      <h1>
        Add Data
        <img src={add_data} alt="" />
      </h1>
      <DataRemaining subId={subId} />
      <AddDataPicker quickSubId={subId} />
    </div>
  )
}

export default AddDataScreen;
